module.exports = __webpack_public_path__ + "img/grey-academy-biznes.2fbb00c9.png";